<meeting-scheduler-duration-multi-select
  [options]="options"
  [duration]="bufferDurationAfterMeeting"
  [title]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.TITLE' | translate"
  [description]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.DESCRIPTION' | translate"
  [hint]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.HINT' | translate"
  (durationSelected)="onDurationSelected($event)"
></meeting-scheduler-duration-multi-select>
